import { useCallback } from 'react';
import { useInventoryId } from '@/hooks/use-inventory-id';
import { useNow } from '@/hooks/use-now';
import {
  useGetPathwayScenariosQuery,
  useDeletePathwayScenarioMutation,
} from '@/api/pathway-scenarios';
import { Loading } from '@/components/loading';
import { Layout } from '@/components/layout';
import { PathwayScenariosList } from '@/components/scenarios-list';

const PathwayScenarios = () => {
  const inventoryId = useInventoryId();
  const now = useNow();
  const { data: scenarios, isLoading: isLoadingPathwayScenarios } =
    useGetPathwayScenariosQuery(inventoryId);
  const [deletePathwayScenario] = useDeletePathwayScenarioMutation();
  const onDeletePathwayScenario = useCallback(
    (scenarioId: number) => {
      deletePathwayScenario({ inventoryId, scenarioId });
    },
    [inventoryId, deletePathwayScenario],
  );

  if (isLoadingPathwayScenarios) {
    return <Loading />;
  }
  return (
    <Layout>
      <PathwayScenariosList
        now={now}
        scenarios={scenarios ?? []}
        onDelete={onDeletePathwayScenario}
      />
    </Layout>
  );
};

export { PathwayScenarios };
